import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "counter"]
  static values = { 
    counterSelector: String,
    itemName: String
  }

  connect() {
    this.updateCounter()
  }

  toggle() {
    this.updateCounter()
  }

  updateCounter() {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked)
    const count = checkedBoxes.length
    
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = count
    }
    
    // Mettre à jour aussi les compteurs par ID si spécifiés
    if (this.hasCounterSelectorValue) {
      const counterElement = document.getElementById(this.counterSelectorValue)
      if (counterElement) {
        counterElement.textContent = count
      }
    }
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
    })
    this.updateCounter()
  }

  selectNone() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateCounter()
  }
}
